import { Form } from 'react-bootstrap';
import styled from 'styled-components';
import { ModalButton } from 'components/ModalDialog/style';
import { STATIC_IMAGE_URLS } from 'modules/core/constants';

export const Panel = styled.div`
  padding: 18px 63px;
  background-color: ${({ theme: { colors } }) => colors.white};
  border-radius: 4px;
  box-shadow: 0 1px 1px rgb(0 0 0 / 5%);
  display: flex;
  flex-direction: column;
`;

export const AIMessage = styled.div`
  font-size: 12px;
  color: black;
  font-style: italic;
  margin-top: 10px;
`;

export const FormControlFeedback = styled(Form.Control.Feedback)`
  display: block;
  font-size: 12px;
  font-style: italic;
  margin-top: 0;
`;

export const UnlockInventoryButton = styled(ModalButton)`
  margin-right: auto;
  display: flex;
  align-items: center;

  &::before {
    content: '';
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-right: 6px;
    background-image: url(${STATIC_IMAGE_URLS.icons.externalLink});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    transition: transform 0.2s ease-in-out;
  }

  &:hover::before {
    transform: translateX(1px) translateY(-1px);
  }
`;
